import { Main } from '@components/Main';
import { PageContent } from '@components/PageContent';
import { PageTitle, PageTitleText } from '@components/PageTitle';
import { TableWrapper } from '@components/Table/TableWrapper';
import { useData } from '@hooks/useData';
import { useField } from '@hooks/useField';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { EnumSortDirection } from '@hooks/useRequest';
import { useValidation } from '@hooks/useValidation';
import IFatura from '@model/Fatura';
import { IFaturaFilter, useRelatorioFaturaService } from '@services/Relatorios/RelatorioFaturaService';
import { yup } from '@validations/Yup';
import React from 'react';
import { FaturaFilter } from './FaturaFilter';
import { FaturaTable } from './FaturaTable';

export type RelatorioFaturaProps = {

}

export function RelatorioFatura (props: RelatorioFaturaProps) {
    const data = useData<IFatura, IFaturaFilter>({
        filter: {
            competencia: useField()
        },

        sortField: {
            name: "faturaId",
            direction: EnumSortDirection.Desc
        }
    });
    
    const loading = useLoading();
    const message = useMessage();
    const relatorioFaturaService = useRelatorioFaturaService();

    const validation = useValidation<IFaturaFilter>({
        competencia: yup.string().required(),
    })

    const handleCsvButtonClick = React.useCallback(() => {
        if (!loading.isLoading) {
            validation.validate(data.requestedData.filter)
                .then(() => {
                    loading.start();
                    relatorioFaturaService.exportar(data.requestedData)
                    .catch(message.showBlobException)
                    .finally(loading.stop);
                })
                .catch(data.filter.setErrorsFromYup);
            }
    }, [data.filter.setErrorsFromYup, data.requestedData, loading, message.showBlobException, relatorioFaturaService, validation]);

    React.useEffect(() => {
        if (!loading.isLoading && data.requestedData.filter.competencia !== undefined) {
            validation.validate(data.requestedData.filter)
                .then(() => {
                    loading.start();
                    relatorioFaturaService.listar(data.requestedData)
                        .then(response => {
                            data.updateDataResponse(response.data);
                        })
                        .catch(message.showException)
                        .finally(loading.stop);
                })
                .catch(data.filter.setErrorsFromYup);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.requestedData]);

    return (
        <React.Fragment>
            <Main>
                <PageTitle>
                    <PageTitleText text="Relatório de Faturas" />
                </PageTitle>

                <PageContent>
                    <FaturaFilter
                        filter={data.filter}
                        isLoading={loading.isLoading}
                    />

                    <TableWrapper>
                        <FaturaTable
                            data={data}
                            isLoading={loading.isLoading}
                            onCsvButtonClick={handleCsvButtonClick}
                        />
                    </TableWrapper>
                </PageContent>
            </Main>
        </React.Fragment>
    )
}